import { useEffect, useState } from "react";
import { authFetch } from "@/lib/auth-fetch";
import { apiUrl } from "@/lib/api-base";

interface JournalStatsResponse {
  lifetimeUnfoldingCount?: number;
}

/**
 * Lifetime unfolding count from `GET /journals/stats`.
 *
 * The list endpoint can only ever report what it returned, so `journals.length`
 * is really "unfoldings currently loaded" — it would silently become wrong the
 * day the list paginates. This is the authoritative number.
 *
 * Returns `null` while loading or on any failure; callers fall back to the local
 * count so a stats outage degrades one number rather than breaking the page.
 */
export function useLifetimeUnfoldingCount(): number | null {
  const [count, setCount] = useState<number | null>(null);

  useEffect(() => {
    let cancelled = false;
    authFetch(apiUrl("/journals/stats"))
      .then((res) => (res.ok ? res.json() : null))
      .then((data: JournalStatsResponse | null) => {
        if (cancelled) return;
        if (typeof data?.lifetimeUnfoldingCount === "number") {
          setCount(data.lifetimeUnfoldingCount);
        }
      })
      .catch(() => {});
    return () => {
      cancelled = true;
    };
  }, []);

  return count;
}
